import { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";
import pageSchemas from "../data/pageSchemas";

const PageSchema = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Prefer an exact page entry before matching generic routes such as ":slug".
    const matchedRoute =
      (Object.prototype.hasOwnProperty.call(pageSchemas, pathname) && pathname) ||
      Object.keys(pageSchemas).find((routePattern) =>
        matchPath({ path: routePattern, end: true }, pathname)
      );

    const schemas = matchedRoute ? pageSchemas[matchedRoute] : [];
    const addedScripts = schemas.map((schema, index) => {
      const script = document.createElement("script");

      script.type = "application/ld+json";
      script.dataset.pageSchema = "true";
      script.dataset.schemaRoute = matchedRoute;
      script.dataset.schemaIndex = String(index);
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);

      return script;
    });

    return () => {
      addedScripts.forEach((script) => script.remove());
    };
  }, [pathname]);

  return null;
};

export default PageSchema;
